<button
  (click)="clickable && onClick($event)"
  [ngClass]="{
    dark: theme == themes.DARK,
    brigth: theme == themes.BR,
    green: theme == themes.GREEN,
    icon: theme == themes.ICON,
    disabled: theme == themes.DISABLED,
    white: theme == themes.WHITE,
    warning: theme == themes.WARNING,
    black: theme == themes.BLACK
  }"
  [ngStyle]="customButtonStyle"
>
  <span
    *ngIf="icon && icon.length > 0"
    [ngClass]="{
      'icon icon-filter-sort-icon': icon == icons.SORT,
      reactive: reactive
    }"
  ></span>

  <span class="label" *ngIf="label && label.length > 0">{{ label }}</span>
</button>
